import { render } from "./icon-message-sent.svg?vue&type=template&id=11aa395c"
const script = {}
script.render = render

export default script